import { filter, sortBy } from 'lodash';
import React, { useState, useCallback, useMemo } from 'react';
import BreadcrumbsContext from './BreadcrumbsContext';
const BreadcrumbsStore = ({ children }) => {
    const defaultState = [];
    const [breadcrumbs, setBreadCrumbs] = useState(defaultState);
    const addAnchor = useCallback(({ title, route, depth, hasQuickLinkButton }) => {
        setBreadCrumbs(breadcrumbs => sortCrumbs([
            ...breadcrumbs,
            { title, route, depth, hasQuickLinkButton },
        ]));
    }, [setBreadCrumbs]);
    const updateAnchor = useCallback(({ title, route, depth, hasQuickLinkButton }) => {
        setBreadCrumbs(breadcrumbs => {
            const updateIndex = breadcrumbs.findIndex(crumb => crumb.route === route);
            return sortCrumbs([
                ...breadcrumbs.slice(0, updateIndex),
                { title, route, depth, hasQuickLinkButton },
                ...breadcrumbs.slice(updateIndex + 1),
            ]);
        });
    }, [setBreadCrumbs]);
    const removeAnchor = useCallback(route => {
        setBreadCrumbs(breadcrumbs => [
            ...filter(breadcrumbs, ({ route: cRoute }) => cRoute !== route),
        ]);
    }, [setBreadCrumbs]);
    const addAnchors = useCallback((depth, rawAnchors) => {
        let nextDepth = depth;
        const anchors = rawAnchors.map(({ route, title, hasQuickLinkButton }) => ({
            title,
            route,
            depth: nextDepth++,
            hasQuickLinkButton,
        }));
        setBreadCrumbs(breadcrumbs => sortCrumbs([...breadcrumbs, ...anchors]));
    }, [setBreadCrumbs]);
    const removeAnchors = useCallback(routes => {
        const routesSet = new Set(routes);
        setBreadCrumbs(breadcrumbs => filter(breadcrumbs, ({ route }) => !routesSet.has(route)));
    }, [setBreadCrumbs]);
    const value = useMemo(() => ({
        addAnchor,
        updateAnchor,
        removeAnchor,
        breadcrumbs,
        addAnchors,
        removeAnchors,
    }), [
        addAnchor,
        updateAnchor,
        removeAnchor,
        breadcrumbs,
        addAnchors,
        removeAnchors,
    ]);
    return (<BreadcrumbsContext.Provider value={value}>
      {children}
    </BreadcrumbsContext.Provider>);
};
export default BreadcrumbsStore;
function sortCrumbs(crumbs) {
    return sortBy(crumbs, 'depth');
}
